import { render } from "./Card.vue?vue&type=template&id=13ab1c27&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=13ab1c27&scoped=true&lang=scss"

import exportComponent from "/Users/johnguanlao/Desktop/wrk/CodeTogether/RSJI-Equity-Actions/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ab1c27"]])

export default __exports__